/**
 * <s-booking-options> is the studio booking request builder.
 * - Joins the ticked equipment into one hidden field so the request email lists it.
 * - When the product has a machine variant and a cutting-table variant, ticking any
 *   machine switches the requested space and the displayed price to the machine rate.
 */
class SBookingOptions extends HTMLElement {
  #ac;
  #lastVariant = '';

  connectedCallback() {
    this.#ac = new AbortController();
    this.addEventListener('change', () => this.#sync(true), { signal: this.#ac.signal });
    this.#sync(false);
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #sync(announce) {
    const target = this.querySelector('[data-booking-equipment-value]');
    if (target instanceof HTMLInputElement) {
      const checked = Array.from(this.querySelectorAll('[data-booking-equipment]:checked'));
      target.value = checked.map((input) => input.value).join(', ');
    }

    this.#syncSpace(announce);
  }

  #syncSpace(announce) {
    const { machineVariant, tableVariant, machineLabel, tableLabel } = this.dataset;
    if (!machineVariant || !tableVariant) return;

    const usesMachine = Boolean(this.querySelector('[data-booking-machine]:checked'));
    const variantId = usesMachine ? machineVariant : tableVariant;
    if (variantId === this.#lastVariant) return;
    this.#lastVariant = variantId;

    const space = this.querySelector('[data-booking-space-value]');
    if (space instanceof HTMLInputElement) space.value = (usesMachine ? machineLabel : tableLabel) || '';

    const scope = this.closest('form')?.parentElement ?? this;
    for (const price of scope.querySelectorAll('[data-variant-price]')) {
      if (price instanceof HTMLElement) price.hidden = price.dataset.variantPrice !== variantId;
    }

    const status = this.querySelector('[data-booking-price-status]');
    if (announce && status instanceof HTMLElement) {
      status.textContent = (usesMachine ? status.dataset.machineMessage : status.dataset.tableMessage) || '';
    }
  }
}

if (!customElements.get('s-booking-options')) {
  customElements.define('s-booking-options', SBookingOptions);
}
